module.exports = __webpack_public_path__ + "img/image43.714ef31f.png";